module.exports = __webpack_public_path__ + "img/weibo.03e69a88.png";